<template>
  <div class="about-us">
    <menuBox :step="5"></menuBox>
    <div class="banner-box" id="home" ref="home">
      <div class="banner-text">
        <div class="title">Contacts us</div>
        <div class="text">
          We'll respond to your project inquiries within 24 hours.
        </div>
      </div>
    </div>
    <div class="help-box">
      <div class="title">
        Our Team
      </div>
      <div class="text">
        We are a passionate and experienced professional team committed to providing innovative and efficient advertising solutions for our clients. With extensive expertise and hands-on experience, our team excels in creative planning, technical support, and collaboration. We always prioritize customer needs, continuously pursuing innovation and improvement.
      </div>
      <div class="list">
        <div class="item">
          → Our team consists of experienced and skilled professionals.
        </div>
        <div class="item">
          → We excel in creative planning.
        </div>
        <div class="item">
          → We have an advanced technical support team.
        </div>
        <div class="item">
          → Customer needs are always our top priority.
        </div>
        <div class="item">
          → We have mature project management process
        </div>
        <div class="item">
          → es and quality control systems.
        </div>
      </div>
      <div class="title">
        Our Mission and Goals
      </div>
      <div class="text">
        Our mission is to provide comprehensive and customized advertising solutions to help our clients achieve their business goals and sustainable growth. Our goal is to become a leading advertising agency in the industry, continuously innovating and striving for excellence, while creating greater value and broader opportunities for our clients.
      </div>
      <img src="../assets/help-1.png" alt="" />
    </div>
    <div class="about-title">
      <div class="info-box">
        <div class="title">
          Contact Us. It's Easy.
        </div>
        <div class="content">
          We look forward to connecting with you and providing professional advertising solutions to help you achieve your business goals. No matter where you are, we're ready to offer support and assistance.
        </div>
        <div class="list">
          <!-- <div class="item">
            <img src="../assets/menu-tel.png" alt="" />
            <div class="text-box">
              <div class="title">
                Our Contact
              </div>
              <div class="text">
                support@omtradersltd.com
              </div>
            </div>
          </div> -->
          <div class="item">
            <img src="../assets/menu-email.png" alt="" />
            <div class="text-box">
              <div class="title">
                Our Email
              </div>
              <div class="text">
                hugh@vista-hk.com。
              </div>
            </div>
          </div>
          <div class="item">
            <img src="../assets/menu-address.png" alt="" />
            <div class="text-box">
              <div class="title">
                Our Address
              </div>
              <div class="text">
                424 Balestier Rd, #02-11 Giffard Mansion, Singapore 32981
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sub-box">
        <div class="flex-box">
          <input type="text" v-model="name" placeholder="Your Name" />
          <input type="text" v-model="email" placeholder="Your Email" />
        </div>
        <textarea
          class="message"
          v-model="message"
          type="text"
          placeholder="Message"
        />
        <div class="btn" @click="submit()">Get Appointment</div>
      </div>
    </div>

    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
      name: "",
      email: "",
      message: "",
    };
  },
  mounted() {},
  methods: {
    submit() {
      this.name = "";
      this.email = "";
      this.message = "";
      alert("Submitted successfully");
    },
  },
};
</script>
<style lang="less" scoped>
.about-us {
  .banner-box {
    background-image: url(../assets/swiper-4.png);
    height: 450px;
    background-size: 100% 100%;
    margin-top: -84px;
    .banner-text {
      margin: 0 360px;
      padding-top: 200px;
      text-align: left;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .title {
        font-family: Roboto, Roboto;
        font-weight: bold;
        font-size: 64px;
        color: #ffffff;
        width: 650px;
      }

      .text {
        font-size: 26px;
        font-weight: 400;
        font-size: 22px;
        color: #ffffff;
        width: 500px;
        margin-top: 20px;
      }
    }
  }
  .help-box {
    margin: 0 360px;
    margin-top: 100px;
    .title {
      font-family: Rubik, Rubik;
      font-weight: 600;
      font-size: 35px;
      color: #1c1f35;
      margin-bottom: 12px;
    }
    .text {
      font-family: Krub, Krub;
      font-weight: 500;
      font-size: 16px;
      color: #666c89;
    }
    .list {
      margin-top: 30px;
      margin-bottom: 75px;
      .item {
        font-family: Rubik, Rubik;
        font-weight: 400;
        font-size: 20px;
        color: #1c1f35;
        margin-bottom: 25px;
      }
    }
    img {
      width: 100%;
      height: 681px;
      margin-top: 30px;
    }
  }
  .about-title {
    background-color: #fff;
    height: 700px;
    margin-top: 200px;
    padding: 0 360px;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    .info-box {
      width: 500px;
      .title {
        font-family: Cabin, Cabin;
        font-weight: bold;
        font-size: 45px;
        color: #181818;
      }
      .content {
        font-family: Lato, Lato;
        font-weight: 400;
        font-size: 16px;
        color: #595566;
        margin-top: 20px;
      }
      .list {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-top: 30px;
        .item {
          display: flex;
          margin-bottom: 60px;
          img {
            width: 50px;
            height: 50px;
            margin-right: 10px;
          }
          .text-box {
            .title {
              font-family: Lato, Lato;
              font-weight: 400;
              font-size: 16px;
              color: #595566;
            }
            .text {
              font-family: Cabin, Cabin;
              font-weight: 600;
              font-size: 20px;
              color: #181818;
              width: 400px;
            }
          }
        }
      }
    }
    .sub-box {
      width: 650px;
      height: 550px;
      margin-top: 50px;
      .flex-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        input {
          width: 270px;
          border-radius: 22px;
        }
      }
      input,
      textarea {
        background-color: #fff;
        width: 600px;
        padding: 0 20px;
        font-family: Lato, Lato;
        font-weight: 400;
        font-size: 16px;
        color: #a9a9a9;
        height: 68px;
        margin-bottom: 20px;
        background: #ffffff;
        border-radius: 22px;
        border: 1px solid #c1c1c1;
      }
      .message {
        height: 120px;
        padding: 20px;
      }
      .btn {
        width: 168px;
        height: 61px;
        background: #0459d8;
        border-radius: 10px 10px 10px 10px;
        font-family: Lato, Lato;
        font-weight: 600;
        font-size: 18px;
        color: #ffffff;
        text-align: center;
        line-height: 61px;
        cursor: pointer;
      }
    }
  }
}
</style>
